import { jitsiLocalStorage } from '@jitsi/js-utils';
import React, { FC, useState } from 'react';


interface SettingsProps {
    onHandleLogOut: () => void
}
export const Settings: FC<SettingsProps> = ({ onHandleLogOut = () => {} }) => {
    return (
        <div className = 'o-settings'>
            <div className = { 'o-settings-log-out' }>
                <div
                    className = { 'o-settings-log-out-button' }
                    onClick = { onHandleLogOut }>
                    <p>Log Out</p>
                </div>
            </div>
        </div>
    );
};
